import dayjs from "dayjs";

export const isDateLessTanOneMinuteAgo = (date: any) => {
  return dayjs().add(-1, 'minutes') >= date
}

export const isDateMoreTanOneMinuteAgo = (date: any) => {
  return dayjs().add(-1, 'minutes') <= date
}

// Запрещает выбор дат в прошлом (до начала текущего дня)
export const isDateInPast = (date: any) => {
  if (!date) return false;
  return date < dayjs().startOf('day');
}